import { InputLabel, InputLabelProps } from '@mui/material';

const GhGasEmissionVerifyLabel = (props: InputLabelProps) => {
  return (
    <InputLabel
      sx={{
        width: '100%',
        minWidth: 250,
        maxWidth: 350,
        marginTop: 1,
        textAlign: 'right',
        whiteSpace: 'inherit',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        '& .MuiInputLabel-asterisk': {
          whiteSpace: 'nowrap',
        },
      }}
      {...props}
    />
  );
};

export default GhGasEmissionVerifyLabel;
